import Cookies from 'js-cookie'

import { $axios } from '@/shared/api/axios'

import { ACCESS_TOKEN_COOKIE_NAME, IS_LOGGED_IN_COOKIE_NAME, VERIFYING_TOKEN_COOKIE_NAME } from '../constants'

const COOKIE_REMOVE_OPTIONS = { path: '/', domain: '.iport.ru' }

const removeCookieEverywhere = (name: string) => {
	Cookies.remove(name, COOKIE_REMOVE_OPTIONS)
	Cookies.remove(name, { path: '/' })
	Cookies.remove(name)
}

export const clearAuthClientState = () => {
	removeCookieEverywhere(ACCESS_TOKEN_COOKIE_NAME)
	removeCookieEverywhere(VERIFYING_TOKEN_COOKIE_NAME)
	removeCookieEverywhere(IS_LOGGED_IN_COOKIE_NAME)
}

export const performLogout = async () => {
	let serverLogoutSucceeded = true

	try {
		await $axios.delete('auth/logout')
	} catch {
		serverLogoutSucceeded = false
	}

	clearAuthClientState()

	return { serverLogoutSucceeded }
}
